var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',[(_vm.isMobile)?_c('bookings-mobile-list',{attrs:{"show-buttons":"","show-search":""}}):_c('bookings-table',{attrs:{"show-buttons":"","show-search":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }